module.exports = __webpack_public_path__ + "img/rope-facade-plaster-repair.730cc42a.jpg";